import React, { useState, useEffect, useRef } from 'react';
import { useMediaQuery, Grid, Hidden } from '@material-ui/core';

import { Submenu, SubmenuItem, TabelaCalendario } from '../../components';

import { etfService } from '../../service/services/EtfService';
import {
	formatDbDate,
	smoothScroll,
	formatCurrencyToBRL,
} from '../../utils/functions';

import {
	Container,
	Title,
	BoxMaiores,
	BoxSegmentacao,
	BoxMovimentacoes,
	BoxCadastro,
	ContentMaiores,
	ContentSegmentacao,
	ContentMovimentacoes,
	ContentCadastro,
	BlockMaiores,
	BlockSegmentacao,
	ImageCadastro,
	Tabela,
	ImagemSegmentacaoLateral,
} from './styles';


const toTitleCase = (phrase) => {

	var dictionary = {

		"PF": "Pessoas físicas",
		"IF": "Instituições financeiras",
		"PJ": "Pessoas jurídicas"
		
	};


	var words = phrase.split(' ')
	var i = 0;
	var newwords = [];
	words.forEach(element => {
		if(i===0 && element.length <= 2){
			newwords.push(dictionary[element]);
		}
		else if(i === 0){
			newwords.push(element.charAt(0).toUpperCase() + element.slice(1).toLowerCase());
		}
		else{
			newwords.push(element.toLowerCase());
		}
		i++;
	});
	return newwords.join(' ');
  };


const getCotista = list => {
	return list.map(item => [item.DsCotista, formatCurrencyToBRL(item.Peso)]);
};

const getSegmentacao = list => {
	return list.map(item => [
		toTitleCase(item.SegmentacaoCotista),
		formatCurrencyToBRL(item.Peso),
	]);
};

const getMovimentacao = list => {
	return list.map(item => [
		formatDbDate('DD/MM/YYYY', item.Data),
		item.TpOperacao,
		formatCurrencyToBRL(item.VlOperacao),
		formatCurrencyToBRL(item.PatrimonioLiquido),
		formatCurrencyToBRL(item.PercPatrimonioLiquidoDia),
	]);
};

export default () => {
	const matches = useMediaQuery('(max-width:768px)');

	const [cotistaData, setCotistaData] = useState(null);
	const [segmentacaoData, setSegmentacaoData] = useState(null);
	const [movimentacaoData, setMovimentacaoData] = useState(null);

	const [maioresCotistasDate, setMaioresCotistasDate] = useState(null);
	const [segmentacaoDate, setSegmentacaoDate] = useState(null);
	const [maioresMovimentacoesDate, setMaioresMovimentacoesDate] = useState(null);

	const cotistaRef = useRef(null);
	const segmentacaoRef = useRef(null);
	const movimentacaoRef = useRef(null);

	const getDateAtualizacao = async () => {
		try {
			const response = await etfService.DatesAtualizacaoCotistas();
			const responseData = await response.data;

			setMaioresCotistasDate(responseData.ObjJsonResultado.MaioresCotistas);
			setSegmentacaoDate(responseData.ObjJsonResultado.MaioresCotistas);
			setMaioresMovimentacoesDate(responseData.ObjJsonResultado.MaioresMovimentacoes);

		} catch (err) {
			setMaioresCotistasDate("");
			setSegmentacaoDate("");
			setMaioresMovimentacoesDate("");
			console.error(
				'Ocorreu um erro ao chamar a API de Cotistas/Datas de atualização - Erro: ',
				err,
			);
		}
	};

	const getMaioresCotistas = async () => {

		try {
			const response = await etfService.MaioresCotistas();
			const responseData = await response.data;

			const cotista = getCotista(responseData.ObjJsonResultado.MaioresCotista);
			setCotistaData(cotista);
		} catch (err) {
			setCotistaData([]);	
			console.error(
				'Ocorreu um erro ao chamar a API de Maiores Cotistas - Erro: ',
				err,
			);
		}
	};

	const getSegmentacaoCotistas = async() => {

		try {
			const response = await etfService.SegmentacaoCotistas();
			const responseData = await response.data;

			const segmentacao = getSegmentacao(
				responseData.ObjJsonResultado.Segmentacao,
			);

			setSegmentacaoData(segmentacao);

		} catch (err) {
			setSegmentacaoData([]);
			console.error(
				'Ocorreu um erro ao chamar a API Segmentacao de Cotistas - Erro: ',
				err,
			);
		}
	};

	const getMaioresMovimentacoes = async() => {

		try {
			const response = await etfService.MaioresMovimentacoes();
			const responseData = await response.data;

			const movimentacao = getMovimentacao(
				responseData.ObjJsonResultado.MaioresMovimentacao,
			);

			setMovimentacaoData(movimentacao);
		} catch (err) {
			setMovimentacaoData([]);
			console.error(
				'Ocorreu um erro ao chamar a API de Maiores Movimentacoes Cotistas - Erro: ',
				err,
			);
		}
	};

	useEffect(() => {
		const getData = async () => {
			await getDateAtualizacao();
			await getMaioresCotistas();
			await getSegmentacaoCotistas();
			await getMaioresMovimentacoes();

		};

		getData();
	}, []);

	return (
		<Container>
			<Hidden mdUp>
				<Title>Cotistas</Title>
			</Hidden>
			<Hidden smDown>
				<Submenu>
					<SubmenuItem
						onClick={() => smoothScroll('#cotista')}
						label="Maiores cotistas"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#segmentacao')}
						label="Segmentação"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#movimentacao')}
						label="Maiores movimentações"
					/>
				</Submenu>
			</Hidden>

			<BoxMaiores>
				<ContentMaiores ref={cotistaRef}>
					<BlockMaiores>
						<h2 id="cotista">Maiores cotistas</h2>
						<Tabela>
							<TabelaCalendario
								variant="dark-blue"
								reference="cot"
								headers={[
									'Cotistas detentores de mais de 5% das cotas',
									'Peso (%)',
								]}
								data={cotistaData}
								hideOptions={true}
								hidePagination={true}
								showUpdateDate={true}
								updateDate={maioresCotistasDate}
								textColorPagination="white"
							/>

						</Tabela>
					</BlockMaiores>
				</ContentMaiores>
			</BoxMaiores>

			<BoxSegmentacao>
				<ContentSegmentacao ref={segmentacaoRef}>
					<Grid container>
						<Grid item lg={4} md={4} sm={12} xs={12} className="SegmentacaoImg">
							<ImagemSegmentacaoLateral/>
						</Grid>
						<Grid
							item
							lg={8}
							md={8}
							sm={12}
							xs={12}
							className="SegmentacaoGrid"
						>
							<h2 id="segmentacao">Segmentação</h2>
							<BlockSegmentacao>
								<Tabela>
									<TabelaCalendario
										variant={matches ? 'light-blue' : 'white'}
										reference="seg"
										headers={['Segmentação de cotistas', 'Peso (%)']}
										data={segmentacaoData}
										hideOptions={true}
										hidePagination={true}
										showUpdateDate={true}
										updateDate={segmentacaoDate}
										backgroudColorPagination="darkblue"
									/>
								</Tabela>
							</BlockSegmentacao>
						</Grid>
					</Grid>
				</ContentSegmentacao>
			</BoxSegmentacao>

			<BoxMovimentacoes>
				<ContentMovimentacoes ref={movimentacaoRef}>
					<h2 id="movimentacao">
						<span>Maiores movimentações</span>
						<strong>
							Integralizações e resgates de cotas superiores a 20% do patrimônio
							líquido (últimos 30 dias).
						</strong>
					</h2>
					<Tabela>
						<TabelaCalendario
							variant={'white'}
							reference="mov"
							headers={[
								'Data',
								'Tipo de movimentação',
								'Valor da movimentação (R$)',
								'Patrimônio Líquido (R$)',
								'Patrimônio Líquido (%)',
							]}
							data={movimentacaoData}
							hideOptions={true}
							hidePagination={true}
							showUpdateDate={true}
							updateDate={maioresMovimentacoesDate}
							backgroudColorPagination="darkblue"
							textColorPagination="darkblue"							
						/>
					</Tabela>
				</ContentMovimentacoes>
			</BoxMovimentacoes>

			<BoxCadastro>
				<ContentCadastro>
					<div>
						<p>Receba todas as novidades sobre este ETF!</p>
						<div>
							<a href="https://forms.neo1.net/FormViewer.aspx?FormId=ZTFyjNXrHOHr0DmKJf%2B2wg%3D%3D">
								Cadastre-se
							</a>
						</div>
					</div>
				</ContentCadastro>
				<ImageCadastro />
			</BoxCadastro>
		</Container>
	);
};
